export const Navbar = () => <div class="topnavtk2" id="myTopnavtk2">
	<a href="https://www.tkeventsregistration.com/coffee-demo" id="LeaveEvent" class="activetk2">Leave</a>
	<div class="dropdowntk2">
		<button class="dropbtntk2">Venue
			<i class="fa fa-caret-down" />
		</button>
		<div class="dropdown-contenttk2">
			<a href="/" title="Return to Lobby">Lobby</a>

			<a href="/The-Lounge" title="The Lounge">The Lounge</a>
			<a href="/Coffee-Talks" title="Coffee Talks">Coffee Talks</a>
			<a href="/The-Forum" title="The Forum">The Forum</a>
		</div>
	</div>

	<a onclick={window.openSupport} title="Help Desk">Help Desk</a>
</div>
